module.exports = __webpack_public_path__ + "static/media/lvl-group-7.894cbc54.png";